import { useEffect, useState } from 'react'
import { authApi } from '../../api/client'
import { useAuthStore } from '../../store/authStore'

interface AuthBootstrapProps {
  children: React.ReactNode
}

/**
 * Validates persisted session via GET /auth/me on app load.
 */
export default function AuthBootstrap({ children }: AuthBootstrapProps) {
  const accessToken = useAuthStore((s) => s.accessToken)
  const updateUser = useAuthStore((s) => s.updateUser)
  const logout = useAuthStore((s) => s.logout)
  const [ready, setReady] = useState(!accessToken)

  useEffect(() => {
    if (!accessToken) {
      setReady(true)
      return
    }

    let cancelled = false
    authApi
      .getMe()
      .then((res) => {
        if (cancelled) return
        updateUser(res.data)
        setReady(true)
      })
      .catch(() => {
        if (cancelled) return
        logout()
        setReady(true)
      })

    return () => {
      cancelled = true
    }
  }, [accessToken, logout, updateUser])

  if (!ready) {
    return null
  }

  return <>{children}</>
}
